var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sect-intro"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.text),function(p){return (_vm.text.length !== 0)?_c('p',{key:p,staticClass:"note"},[_vm._v(_vm._s(p))]):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }